 import { HttpClient, HttpParams } from '@angular/common/http';
import { LazyLoadEvent, TreeNode } from 'primeng/primeng'; 
import { Observable } from 'rxjs';
 import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { RegisterDetail } from '../entities/registerDetail';    
import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service'; 
import {  tap} from 'rxjs/operators';


@Injectable()
export class RegisterDetailService  extends BaseCrudService<RegisterDetail>
  { 
    public uri = '/api/registerDetail/';

    constructor(injector: Injector) {
        super(injector); 
       //console.log('Instance RegisterDetailService');
    }
 
    buildSentence(entity?: RegisterDetail, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = '';
            //let query = entity.code ? 'code' + QueryOperator.Contain + entity.code + QueryOperator.Split : QueryOperator.Empty;
            //query = query.concat(entity.name ? 'name' + QueryOperator.Contain + entity.name + QueryOperator.Split : QueryOperator.Empty);
            
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
   
}



// WEBPACK FOOTER //
// ./src/app/core/services/register-detail.service.ts